<template lang="pug">
  .pho-select
    PhoValidationProvider(:rules="rules" :name="name")
      v-select(
        v-model="lazyValue"
        v-on="$listeners"
        spellcheck="false"
        :clearable="clearable"
        :items="lazyItem"
        :item-value="itemValue"
        :item-text="itemText"
        :multiple="multiple"
        :label="label"
        :readonly="readonly"
        :disabled="disabled"
        :dense="dense"
        :outlined="outlined"
        :prepend-icon="prependIcon"
        :return-object="returnObject"
      )
</template>

<script>
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { useSelectedSorter } from '@/helpers/misc';
import { filterSelectedValues } from '@/helpers/content';
import {
  onMounted, ref, watch,
} from 'vue';
import PhoValidationProvider from './PhoValidationProvider.vue';

export default {
  name: 'PhoSelect',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
    },
    itemText: {
      type: [String, Array],
      default: 'text',
    },
    itemValue: {
      type: [String, Array],
      default: 'value',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);
    const items = ref([]);
    const getItems = () => {
      items.value = props.items || [];
    };

    onMounted(() => {
      getItems();
    });

    watch(() => props.items, () => getItems());

    const [lazyItem] = useSelectedSorter(items, lazyValue, filterSelectedValues, 'id');

    return {
      lazyValue,
      lazyItem,
    };
  },
};
</script>
